import React from "react";
import "./Report.scss";
import { Breadcrumbs } from "@netapp/bxp-design-system-react";
import Card from "./card/Card";
import { LangLink } from "../../utils/langNavigation";
import { useTranslation } from "react-i18next";

const Report = () => {
  const { t } = useTranslation();
  return (
    <div className="reportFrame">
      <div className="first-frame-report">
        <div className="inside-first-frame content-padding">
          <Breadcrumbs className="breadcrumb-container">
            <LangLink to="/" className="breadcrumb-link">{t("secPortal_title.other")}</LangLink>
            <div className="breadcrumb-active">{t("secPortal_reportIssue.other")}</div>
          </Breadcrumbs>

          <div className="aboutFrame">
            <h1 className="reportFrameTitle">
              {t("secPortal_reportIssue.other")}
            </h1>
            <p className="reportFrameDesc">
              {t("secPortal_report_desc.other")}
            </p>
          </div>
        </div>
      </div>

      <div className="frame2-report">
        <div className="cardFrameReport">
          <Card
            imgSrc={"ic_chat.png"}
            title={t("secPortal_report_issueProductsServices.other")}
            text={t("secPortal_report_potentialVulnerabilityProductsServices.other")}
            link={"mailto:security-alert@netapp.com"}
            linkText={"security-alert@netapp.com"}
          />
          <Card
            imgSrc={"ic_chat.png"}
            title={t("secPortal_report_issueNetappDotCom.other")}
            text={t("secPortal_report_incidentCorporateNetworkOrWebsite.other")}
            link={"mailto:ng-csirt-notify@netapp.com"}
            linkText={"ng-csirt-notify@netapp.com"}
          />
        </div>

        <div className="report-details">
          <p className="report-details-text">
            {t("secPortal_report_emailUsageNotice.other")}
          </p>
          <p className="report-details-text">
            {t("secPortal_report_encryptInfoGpgFingerprint.other")}
          </p>
          <p className="report-details-text">
            {t("secPortal_report_acknowledgementTimeline.other")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Report;